<template>
<!-- registration Section 02 -->
<div class="registration">
    <section class>
        <div class="container_1">
            <div class="row justify-content-center">
                <div class="col-lg-12 order-lg-2">
                    <div class="hero-image">
                        <img src="/assets/exported/reg.jpg" alt />
                    </div>
                </div>
            </div>
        </div>
    </section>
    <div class="container rg_hero">
        <div id="name_check"></div>
        <h2>{{ $root.rg_head.rg_text }}</h2>
        <form @submit.prevent="registersubmit" name="form" method="post">
            <div class="container">
                <label for="name">
                    <b>{{ $root.rg_name.rg_n_text }}</b>
                </label>
                <input oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);" type="text" maxlength="38" name="name" v-model="newuser.name" @input="nameError = false" />
                <div class="error_body" v-if="
              typeof errormessage.errors != 'undefined' && nameError == true
            ">
                    <ul v-if="typeof errormessage.errors.name != 'undefined'">
                        <li v-for="name_id in errormessage.errors.name" :key="name_id.id" class="error_data">
                            {{ name_id }}
                        </li>
                    </ul>
                </div>
                <div>
                    <div class="row_rg">
                        <div class="column left_box_t">
                            <div id="number_check"></div>
                            <label for="uname">
                                <b>{{ $root.login_email.login_e_text }}</b>
                            </label>
                            <input class="error-fleid" type="text" name="email" v-model="newuser.email" @input="emailError = false" />
                            <!-- Error masaage -->
                            <div class="error_body" v-if="
                    typeof errormessage.errors != 'undefined' &&
                    emailError == true
                  ">
                                <ul v-if="typeof errormessage.errors.email != 'undefined'">
                                    <li v-for="email_id in errormessage.errors.email" :key="email_id.id" class="error_data">
                                        {{ email_id }}
                                    </li>
                                </ul>
                            </div>

                            <!-- Error masaage end-->
                        </div>
                        <div class="column right_box_t number_padding" style="position: relative">
                            <div id="Affiliated_check"></div>
                            <label for="number">
                                <b>{{ $root.rg_number.rg_m_text }}</b>
                            </label>
                            <input oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);" @input="numberError = false" maxlength="11" type="number" v-model="newuser.number" placeholder name="number" @keypress="onlyNumber" />
                            <label for="youPhonecode" class="static-value">+88</label>
                            <!-- Error masaage -->
                            <div class="error_body">
                                <ul>
                                    <li class="error_data">{{ checkresult }}</li>
                                </ul>
                            </div>
                            <!-- Error masaage end-->
                            <!-- Error masaage -->
                            <div class="error_body" v-if="
                    typeof errormessage.errors != 'undefined' &&
                    numberError == true
                  ">
                                <ul v-if="
                      typeof errormessage.errors.phone_number != 'undefined'
                    ">
                                    <li v-for="phone_id in errormessage.errors.phone_number" :key="phone_id.id" class="error_data">
                                        {{ phone_id }}
                                    </li>
                                </ul>
                            </div>
                            <!-- Error masaage end-->
                        </div>
                    </div>
                </div>
                <div class="row_rg">
                    <div class="column left_box_t">
                        <div class="profile-fields">
                            <div class="profile-field-name">
                                <label for="uname">
                                    <b>{{ $root.rg_add.rg_add_text }}</b>
                                </label>
                            </div>
                            <div id="gender_check"></div>
                            <div class="profile-field-input">
                                <select v-model="newuser.Affiliated" name="affiliated_id" id="affiliated_id" class="column_button button" @change="Affiliants" @input="affiliatedError = false">
                                    <option value disabled selected hidden>
                                        {{ $root.select.text_select }}
                                    </option>
                                    <option v-for="(aff, d_index) in Affiliated" :key="d_index" :value="aff.id">
                                        {{ aff.name }}
                                    </option>
                                </select>
                                <!-- Error masaage-->
                                <div class="error_body" v-if="
                      typeof errormessage.errors != 'undefined' &&
                      affiliatedError == true
                    ">
                                    <ul v-if="
                        typeof errormessage.errors.affiliated_id != 'undefined'
                      ">
                                        <li v-for="aff_id in errormessage.errors.affiliated_id" :key="aff_id.id" class="error_data">
                                            {{ aff_id }}
                                        </li>
                                    </ul>
                                </div>
                                <!-- Error masaage end -->
                            </div>
                        </div>
                    </div>
                    <div class="column col-sm-6 row_rg_bt right_box_t button_color">
                        <label for="uname" style="display: block">
                            <b>{{ $root.rg_gender.rg_gen_text }}</b>
                        </label>
                        <div class="radio-toolbar">
                            <input v-model="newuser.gender" type="radio" id="radio1" name="radio" value="Male" @input="genderError = false" />
                            <label for="radio1">{{ $root.rg_gender1.rg_gen_text1 }}</label>
                            <input class="zoom" v-model="newuser.gender" type="radio" id="radio2" name="radio" value="Female" @input="genderError = false" />
                            <label for="radio2">{{ $root.rg_gender2.rg_gen_text2 }}</label>
                            <input v-model="newuser.gender" type="radio" id="radio3" name="radio" value="Others" @input="genderError = false" />
                            <label for="radio3">{{ $root.rg_gender3.rg_gen_text3 }}</label>
                            <!-- Error masaage-->
                            <div class="error_body" v-if="
                    typeof errormessage.errors != 'undefined' &&
                    genderError == true
                  ">
                                <ul v-if="typeof errormessage.errors.gender != 'undefined'">
                                    <li v-for="gender_id in errormessage.errors.gender" :key="gender_id.id" class="error_data">
                                        {{ gender_id }}
                                    </li>
                                </ul>
                            </div>
                            <!-- Error masaage end -->
                        </div>
                    </div>
                </div>
                <div id="designation_check"></div>
                <label for="psw">
                    <b>{{ $root.rg_ins.rg_ins_text }}</b>
                </label>
                <input v-model="newuser.organization" @input="organizationerror = false" type="text" oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);" maxlength="60" placeholder name="org" />
                <!-- Error masaage-->
                <div class="error_body" v-if="
              typeof errormessage.errors != 'undefined' &&
              organizationerror == true
            ">
                    <ul v-if="typeof errormessage.errors.organization != 'undefined'">
                        <li v-for="des_id in errormessage.errors.organization" :key="des_id.id" class="error_data">
                            {{ des_id }}
                        </li>
                    </ul>
                </div>
                <!-- Error masaage end -->
                <div id="age_check"></div>
                <div class="row_rg">
                    <div class="column left_box_t">
                        <div class="profile-fields">
                            <div class="profile-field-name">
                                <label for="uname">
                                    <b>{{ $root.rg_designation.rg_des_text }}</b>
                                </label>
                            </div>
                            <div class="profile-field-input">
                                <select v-model="newuser.designation" name="designation_id" id="designation_id" class="column_button button" @change="ChangeDesignation" @input="designationerror = false">
                                    <option value disabled selected hidden>
                                        {{ $root.select.text_select }}
                                    </option>
                                    <option v-for="(aff, d_index) in Designation" :key="d_index" :value="aff.id">
                                        {{ aff.name }}
                                    </option>
                                </select>
                                <!-- Error masaage-->
                                <div class="error_body" v-if="
                      typeof errormessage.errors != 'undefined' &&
                      designationerror == true
                    ">
                                    <ul v-if="
                        typeof errormessage.errors.designation_id != 'undefined'
                      ">
                                        <li v-for="des_id in errormessage.errors.designation_id" :key="des_id.id" class="error_data">
                                            {{ des_id }}
                                        </li>
                                    </ul>
                                </div>
                                <!-- Error masaage end -->
                            </div>
                        </div>
                    </div>
                    <div class="column right_box_t">
                        <div id="password_check"></div>
                        <label for="uname">
                            <b>{{ $root.rg_age.rg_age_text }}</b>
                        </label>
                        <div class="profile-field-input">
                            <select v-model="newuser.age" @input="ageerror = false">
                                <option value disabled selected hidden>
                                    {{ $root.select.text_select }}
                                </option>
                                <option value="10">১০</option>
                                <option value="11">১১</option>
                                <option value="12">১২</option>
                                <option value="13">১৩</option>
                                <option value="14">১৪</option>
                                <option value="15">১৫</option>
                                <option value="16">১৬</option>
                                <option value="17">১৭</option>
                                <option value="18">১৮</option>
                                <option value="19">১৯</option>
                                <option value="20">২০</option>
                                <option value="21">২১</option>
                                <option value="22">২২</option>
                                <option value="23">২৩</option>
                                <option value="24">২৪</option>
                                <option value="25">২৫</option>
                                <option value="26">২৬</option>
                                <option value="27">২৭</option>
                                <option value="28">২৮</option>
                                <option value="29">২৯</option>
                                <option value="30">৩০</option>
                                <option value="31">৩১</option>
                                <option value="32">৩২</option>
                                <option value="33">৩৩</option>
                                <option value="34">৩৪</option>
                                <option value="35">৩৫</option>
                                <option value="36">৩৬</option>
                                <option value="37">৩৭</option>
                                <option value="38">৩৮</option>
                                <option value="39">৩৯</option>
                                <option value="40">৪০</option>
                                <option value="41">৪১</option>
                                <option value="42">৪২</option>
                                <option value="43">৪৩</option>
                                <option value="44">৪৪</option>
                                <option value="45">৪৫</option>
                                <option value="46">৪৬</option>
                                <option value="47">৪৭</option>
                                <option value="48">৪৮</option>
                                <option value="49">৪৯</option>
                                <option value="50">৫০</option>
                                <option value="51">৫১</option>
                                <option value="52">৫২</option>
                                <option value="53">৫৩</option>
                                <option value="54">৫৪</option>
                                <option value="55">৫৫</option>
                                <option value="56">৫৬</option>
                                <option value="57">৫৭</option>
                                <option value="58">৫৮</option>
                                <option value="59">৫৯</option>
                                <option value="60">৬০</option>
                                <option value="61">৬১</option>
                                <option value="62">৬২</option>
                                <option value="63">৬৩</option>
                                <option value="64">৬৪</option>
                                <option value="65">৬৫</option>
                                <option value="66">৬৬</option>
                                <option value="67">৬৭</option>
                                <option value="68">৬৮</option>
                                <option value="69">৬৯</option>
                                <option value="70">৭০</option>
                            </select>
                        </div>
                        <!-- Error masaage-->
                        <div class="error_body" v-if="
                  typeof errormessage.errors != 'undefined' && ageerror == true
                ">
                            <ul v-if="typeof errormessage.errors.age != 'undefined'">
                                <li v-for="age_id in errormessage.errors.age" :key="age_id.id" class="error_data">
                                    {{ age_id }}
                                </li>
                            </ul>
                        </div>
                        <!-- Error masaage end -->
                    </div>
                </div>
                <div ref="designation_others_show" id="designation_show">
                    <label for="psw">
                        <b>আপনার পদবী</b>
                    </label>
                    <input v-model="newuser.designation_other" @input="designationerror = false" type="text" placeholder name="dis" />
                    <!-- Error masaage-->
                    <div class="error_body" v-if="
                typeof errormessage.errors != 'undefined' &&
                designationerror == true
              ">
                        <ul v-if="
                  typeof errormessage.errors.designation_other != 'undefined'
                ">
                            <li v-for="des_id in errormessage.errors.designation_other" :key="des_id.id" class="error_data">
                                {{ des_id }}
                            </li>
                        </ul>
                    </div>
                    <!-- Error masaage end -->
                </div>
                <div>
                    <div class="row_rg">
                        <div class="column left_box_t">
                            <label for="uname">
                                <b>{{ $root.login_password.login_p_text }}</b>
                            </label>
                            <input type="password" placeholder v-model="newuser.password" name="password" @input="passworderror = false" />
                            <!-- Error masaage-->
                            <div class="error_body" v-if="
                    typeof errormessage.errors != 'undefined' &&
                    passworderror == true
                  ">
                                <ul v-if="typeof errormessage.errors.password != 'undefined'">
                                    <li v-for="password_id in errormessage.errors.password" :key="password_id.id" class="error_data">
                                        {{ password_id }}
                                    </li>
                                </ul>
                            </div>
                            <!-- Error masaage end -->
                        </div>

                        <div class="column right_box_t">
                            <label for="uname">
                                <b>{{ $root.rg_re_pass.rg_re_pass_text }}</b>
                            </label>
                            <input type="password" placeholder v-model="newuser.confirmpassword" name="confirm_password" @input="conpassworderror = false" />
                            <!-- Error masaage -->
                            <div class="error_body" v-if="
                    typeof errormessage.errors != 'undefined' &&
                    conpassworderror == true
                  ">
                                <ul v-if="
                      typeof errormessage.errors.password_confirmation !=
                      'undefined'
                    ">
                                    <li v-for="confir_pass_id in errormessage.errors
                        .password_confirmation" :key="confir_pass_id.id" class="error_data">
                                        {{ confir_pass_id }}
                                    </li>
                                </ul>
                            </div>
                            <!-- Error masaage end -->
                        </div>
                    </div>
                </div>
                <div>
                    <div class="row_rg">
                        <div class="column left_box_t">
                            <div class="profile-fields">
                                <div class="profile-field-name">
                                    <div id="division_check"></div>
                                    <label for="uname">
                                        <b>{{ $root.rg_division.rg_divi_text }}</b>
                                    </label>
                                </div>
                                <div class="profile-field-input">
                                    <select v-model="newuser.division" name="division_id" class="column_button button" tabindex="1" @change="changeDivision(false)" @input="divisionerror = false">
                                        <option value disabled selected hidden>
                                            {{ $root.select.text_select }}
                                        </option>
                                        <option v-for="(divi, d_index) in division" :key="d_index" :value="divi.id">
                                            {{ divi.name }}
                                        </option>
                                    </select>
                                    <!-- Error masaage -->
                                    <div class="error_body" v-if="
                        typeof errormessage.errors != 'undefined' &&
                        divisionerror == true
                      ">
                                        <ul v-if="
                          typeof errormessage.errors.division_id != 'undefined'
                        ">
                                            <li v-for="up_id in errormessage.errors.division_id" :key="up_id.id" class="error_data">
                                                {{ up_id }}
                                            </li>
                                        </ul>
                                    </div>
                                    <!-- Error masaage end -->
                                </div>
                            </div>
                        </div>
                        <div class="column right_box_t">
                            <div class="profile-fields">
                                <div class="profile-field-name">
                                    <label for="uname">
                                        <b>{{ $root.rg_district.rg_dist_text }}</b>
                                    </label>
                                </div>
                                <div class="profile-field-input">
                                    <select v-model="newuser.districts" name="district_id" class="column_button button" tabindex="1" @change="changeDistrict(false)" @input="Districterror = false">
                                        <option v-if="newuser.districts == ''" value disabled selected hidden>
                                            {{ $root.select.text_select }}
                                        </option>
                                        <option v-for="(dis, d_index) in districts" :key="d_index" :value="dis.id">
                                            {{ dis.name }}
                                        </option>
                                    </select>
                                    <!-- Error masaage -->
                                    <div class="error_body" v-if="
                        typeof errormessage.errors != 'undefined' &&
                        Districterror == true
                      ">
                                        <ul v-if="
                          typeof errormessage.errors.district_id != 'undefined'
                        ">
                                            <li v-for="up_id in errormessage.errors.district_id" :key="up_id.id" class="error_data">
                                                {{ up_id }}
                                            </li>
                                        </ul>
                                    </div>
                                    <!-- Error masaage end -->
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div>
                    <div class="row_rg">
                        <div class="column left_box_t">
                            <div class="profile-fields">
                                <div class="profile-field-name">
                                    <label for="uname">
                                        <b>{{ $root.rg_upazila.rg_upazala_text }}</b>
                                    </label>
                                </div>
                                <div class="profile-field-input">
                                    <select v-model="newuser.upazillas" name="upazilla_id" class="column_button button" tabindex="1" @input="upazillaerror = false">
                                        <option v-if="newuser.upazillas == ''" value disabled selected hidden>
                                            {{ $root.select.text_select }}
                                        </option>
                                        <option v-for="(upaz, d_index) in upazillas" :key="d_index" :value="upaz.id">
                                            {{ upaz.name }}
                                        </option>
                                    </select>
                                    <!-- Error masaage -->
                                    <div class="error_body" v-if="
                        typeof errormessage.errors != 'undefined' &&
                        upazillaerror == true
                      ">
                                        <ul v-if="
                          typeof errormessage.errors.upazilla_id != 'undefined'
                        ">
                                            <li v-for="up_id in errormessage.errors.upazilla_id" :key="up_id.id" class="error_data">
                                                {{ up_id }}
                                            </li>
                                        </ul>
                                    </div>
                                    <!-- Error masaage end -->
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="sub_reg reg_button_p">
                    <button type="submit">{{ $root.rg_head.rg_text }}</button>
                </div>
            </div>
        </form>
    </div>
</div>
</template>

<script>
import swal from "sweetalert";
import axios from "axios";
//import Icondown from "../../assets/svg/iconrowdown.vue";
//import IconUp from "../../assets/svg/iconRowUp.vue";
export default {
    data() {
        return {
            openUp: false,
            openDown: true,
            openUpage: true,
            openDwonage: true,
            division: [],
            districts: [],
            upazillas: [],
            Affiliated: [],
            Designation: [],
            dis: [],
            designationshow_id: "",
            newuser: {
                name: "",
                email: "",
                number: "",
                gender: "",
                organization: "",
                Affiliated: "",
                age: "",
                designation: "",
                designation_other: "",
                password: "",
                confirmpassword: "",
                division: "",
                districts: "",
                upazillas: "",
                movie: null,
            },
            max: 3,
            errormessage: [],
            errors: [],
            phone_number: [],
            email: [],
            age: [],
            gender: [],
            affiliated_id: [],
            designation_id: [],
            organization: [],
            password: [],
            upazilla_id: [],
            name: [],
            password_confirmation: [],
            district_id: [],
            division_id: [],
            firstThree: "",
            checkresult: "",
            nameError: false,
            emailError: false,
            numberError: false,
            affiliatedError: false,
            genderError: false,
            organizationerror: false,
            designationerror: false,
            ageerror: false,
            passworderror: false,
            conpassworderror: false,
            upazillaerror: false,
            Districterror: false,
            divisionerror: false,
        };
    },
    components: {
        //"icondown": Icondown,
        //"iconUp":IconUp,
    },
    beforeMount() {
        this.$root.registration_hook = this;
    },
    beforeDestroy() {
        this.$root.registration_hook = null;
    },
    mounted() {
        this.reloadAPI();
    },
    computed: {},
    methods: {
        onlyNumber($event) {
            let keyCode = $event.keyCode ? $event.keyCode : $event.which;
            if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) {
                // 46 is dot
                $event.preventDefault();
            }
            // var isError = false;
            // var firstOne = this.newuser.number.substring(0, 1);
            // var firstTwo = this.newuser.number.substring(0, 2);
            // var firstThree = this.newuser.number.substring(0, 3);
            // if (firstOne != "0") {
            //   isError = true;
            // } else {
            //   if (firstTwo != "01") {
            //     isError = true;
            //   } else {
            //     if (
            //       firstThree == "010" ||
            //       firstThree == "011" ||
            //       firstThree == "012"
            //     ) {
            //       isError = true;
            //     }
            //   }
            // }
            // if (isError == true && this.newuser.number.length > 3) {
            //   //alert("Wrong Number! " + firstThree);
            //   this.checkresult = "নম্বরটি সঠিক ভাবে লিখুন!";
            // }
        },
        reloadAPI() {
            var config = {
                headers: {
                    "X-localization": this.$root.translate ? "bn" : "en",
                },
            };
            axios
                .get(this.$root.API_BASE_URL + "getdivison", config)
                .then((response) => {
                    if (response.data == []) {
                        // Blank
                        return;
                    }
                    this.division = response.data.data;
                });
            axios
                .get(this.$root.API_BASE_URL + "affilateds", config)
                .then((response) => {
                    if (response.data == []) {
                        // Blank
                        return;
                    }
                    this.Affiliated = response.data.data;
                });
            axios
                .get(this.$root.API_BASE_URL + "designation", config)
                .then((response) => {
                    if (response.data == []) {
                        // Blank
                        return;
                    }

                    this.Designation = response.data.data;
                    console.log(this.Designation[12]);
                });
        },
        registersubmit() {
            axios
                .post("https://adolescent.nnsop.org/admin-panel/api/registration-web", {
                    name: this.newuser.name,
                    email: this.newuser.email,
                    phone_number: this.newuser.number,
                    affiliated_id: this.newuser.Affiliated,
                    gender: this.newuser.gender,
                    age: this.newuser.age,
                    organization: this.newuser.organization,
                    designation_id: this.newuser.designation,
                    designation_other: this.newuser.designation_other,
                    password: this.newuser.password,
                    password_confirmation: this.newuser.confirmpassword,
                    division_id: this.newuser.division,
                    district_id: this.newuser.districts,
                    upazilla_id: this.newuser.upazillas,
                    //token : this.newuser.token
                })
                .then(() => {
                    window.localStorage.clear();
                    this.$router.push({
                        path: "/login",
                    });

                    //console.log(response.data);
                    //localStorage.setItem("profile", JSON.stringify(response.data));
                    //localStorage.setItem(response.data.token)
                    //this.$root.user_profile = response.data;
                    //this.$router.push({ path: "/my_learning" });
                })
                .catch((error) => {
                    if (navigator.onLine) {
                        this.errormessage = error.response.data;
                        console.log("ERRRR:: ", error.response.data);

                        if (typeof this.errormessage.errors.name != "undefined") {
                            this.nameError = true;
                            const el = document.getElementById("name_check");
                            el.scrollIntoView({
                                behavior: "smooth",
                            });
                        } else if (typeof this.errormessage.errors.email != "undefined") {
                            this.emailError = true;
                            const el = document.getElementById("name_check");
                            el.scrollIntoView({
                                behavior: "smooth",
                            });
                        } else if (
                            typeof this.errormessage.errors.phone_number != "undefined"
                        ) {
                            this.numberError = true;
                            const el = document.getElementById("name_check");
                            el.scrollIntoView({
                                behavior: "smooth",
                            });
                        } else if (
                            typeof this.errormessage.errors.affiliated_id != "undefined"
                        ) {
                            this.affiliatedError = true;
                            const el = document.getElementById("number_check");
                            el.scrollIntoView({
                                behavior: "smooth",
                            });
                        } else if (typeof this.errormessage.errors.gender != "undefined") {
                            this.genderError = true;
                            const el = document.getElementById("number_check");
                            el.scrollIntoView({
                                behavior: "smooth",
                            });
                        } else if (typeof this.errormessage.errors.gender != "undefined") {
                            this.genderError = true;
                            const el = document.getElementById("Affiliated_check");
                            el.scrollIntoView({
                                behavior: "smooth",
                            });
                        } else if (
                            typeof this.errormessage.errors.organization != "undefined"
                        ) {
                            this.organizationerror = true;
                            const el = document.getElementById("Affiliated_check");
                            el.scrollIntoView({
                                behavior: "smooth",
                            });
                        } else if (
                            typeof this.errormessage.errors.designation_other != "undefined"
                        ) {
                            this.designationerror = true;
                            const el = document.getElementById("designation_check");
                            el.scrollIntoView({
                                behavior: "smooth",
                            });
                        } else if (
                            typeof this.errormessage.errors.designation_id != "undefined"
                        ) {
                            this.designationerror = true;
                            const el = document.getElementById("designation_check");
                            el.scrollIntoView({
                                behavior: "smooth",
                            });
                        } else if (typeof this.errormessage.errors.age != "undefined") {
                            this.ageerror = true;
                            const el = document.getElementById("designation_check");
                            el.scrollIntoView({
                                behavior: "smooth",
                            });
                        } else if (
                            typeof this.errormessage.errors.password != "undefined"
                        ) {
                            this.passworderror = true;
                            const el = document.getElementById("designation_check");
                            el.scrollIntoView({
                                behavior: "smooth",
                            });
                        } else if (
                            typeof this.errormessage.errors.password_confirmation !=
                            "undefined"
                        ) {
                            this.conpassworderror = true;
                            const el = document.getElementById("designation_check");
                            el.scrollIntoView({
                                behavior: "smooth",
                            });
                        } else if (
                            typeof this.errormessage.errors.division_id != "undefined"
                        ) {
                            this.divisionerror = true;
                            const el = document.getElementById("designation_check");
                            el.scrollIntoView({
                                behavior: "smooth",
                            });
                        } else if (
                            typeof this.errormessage.errors.district_id != "undefined"
                        ) {
                            this.Districterror = true;
                            const el = document.getElementById("designation_check");
                            el.scrollIntoView({
                                behavior: "smooth",
                            });
                        } else if (
                            typeof this.errormessage.errors.upazilla_id != "undefined"
                        ) {
                            this.upazillaerror = true;
                            const el = document.getElementById("password_check");
                            el.scrollIntoView({
                                behavior: "smooth",
                            });
                        }
                    } else {
                        //offline Status
                        swal({
                            text: "আপনার ইন্টারনেট কানেকশনটি একটিভেট করুন",
                            buttons: {
                                confirm: {
                                    text: "ঠিক আছে",
                                },
                            },
                        });
                        //this.connectionStatus = "Unable to connect to internet.";
                    }
                });
        },
        toggledropdown() {
            this.openUp = !this.openUp;
            this.openDown = !this.openDown;
        },
        toggleage() {
            this.openUpage = !this.openUpage;
            this.openDownage = !this.openDownage;
        },
        Affiliants() {
            document.getElementsByName("affiliated_id")[0];
        },
        ChangeDesignation() {
            var d = document.getElementsByName("designation_id")[0];
            var designationshow_id = d.options[d.selectedIndex].value;
            if (designationshow_id == 13) {
                this.$refs.designation_others_show.style.display = "block";
            } else {
                this.$refs.designation_others_show.style.display = "none";
            }
        },
        changeDivision(firstTime) {
            var d = document.getElementsByName("division_id")[0];
            var division_id = d.options[d.selectedIndex].value;
            if (division_id != "") {
                this.division.forEach((element) => {
                    if (element.id == division_id) {
                        this.districts = element.districts;
                    }
                });
                if (!firstTime) {
                    this.upazillas = "";
                    this.newuser.upazillas = "";
                    this.newuser.districts = "";
                }
            }
        },
        changeDistrict(firstTime) {
            var d = document.getElementsByName("district_id")[0];
            var district_id = d.options[d.selectedIndex].value;
            if (district_id != "") {
                this.districts.forEach((element) => {
                    if (element.id == district_id) {
                        this.upazillas = element.upazillas;
                    }
                });
                if (!firstTime) {
                    // this.newuser.upazillas = ' ';
                }
            }
        },
    },
};
</script>

<style scoped>
.static-value {
    position: absolute;
    left: 10px;
    font-size: 1.2em;
    color: #000;
    padding: 8px;
}

.number_padding input[type="number"] {
    padding: 12px 5px 12px 35px;
}

input[type="email"],
input[type="number"] {
    width: 100%;
    padding: 12px 20px;
    margin: 8px 0;
    display: inline-block;
    border: 1px solid #ccc;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    border-radius: 6px;
}

.error-fleid {
    transition: border-color 0.5s ease-out;
}

input:required:valid {
    border-color: green;
}

.error-fleid:invalid {
    background: url("/assets/exported/error.svg") no-repeat 98.1% 50%;
    background-size: 16px;
}

.reg_button_p {
    padding: 60px 0px 0px 0px;
}

#designation_show {
    display: none;
}

@media screen and (max-width: 768px) {
    .error {
        font-size: 18px;
    }

    .number_padding input[type="number"] {
        padding: 6px 5px 6px 28px;
    }

    .static-value {
        font-size: 1em;
        color: rgb(10, 9, 9);
        padding: 3px 5px;
    }

    input[type="email"],
    input[type="number"] {
        width: 100%;
        padding: 6px 20px;
        margin: 8px 0;
        display: inline-block;
        border: 1px solid #ccc;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        border-radius: 6px;
    }
}

@media screen and (max-width: 1500px) {
    .error-fleid:invalid {
        background: url("/assets/exported/error.svg") no-repeat 97.2% 50%;
        background-size: 16px;
    }
}

@media screen and (max-width: 768px) {
    .error {
        font-size: 18px;
    }

    input[type="email"] {
        width: 100%;
        padding: 6px 20px;
        margin: 8px 0;
        display: inline-block;
        border: 1px solid #ccc;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        border-radius: 6px;
    }

    .error-fleid:invalid {
        background: url("/assets/exported/error.svg") no-repeat 97.2% 50%;
        background-size: 14px;
    }
}

@media screen and (max-width: 480px) {
    .error-fleid:invalid {
        background: url("/assets/exported/error.svg") no-repeat 96% 50%;
        background-size: 14px;
    }
}

@media screen and (max-width: 400px) {
    .static-value {
        left: 0px;
    }
}
</style>
